import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-empty-layout',
  standalone: false,
  templateUrl: './empty-layout.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './empty-layout.component.css'
})
export class EmptyLayoutComponent {
}
